/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { FilledButton } from '@neo4j-ndl/react';
import { Presence } from '@neo4j-ndl/react/ai';
import { useState } from 'react';

const Component = () => {
  const [isThinking, setIsThinking] = useState(false);

  return (
    <div className="n-flex n-gap-token-8">
      <Presence className="n-size-token-32" isThinking={isThinking} />
      <FilledButton onClick={() => setIsThinking(!isThinking)}>
        Toggle Thinking
      </FilledButton>
    </div>
  );
};

export default Component;
